import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c61d6550&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./assets/index.response.css?vue&type=style&index=0&id=c61d6550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61d6550",
  null
  
)

export default component.exports